import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

const QuesPublishPopup = ({
  openPopup,
  setOpenPopup,
  handleSave,
  isSaving,
}) => {
  return (
    <div>
      <Dialog
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        id="mars-super-admin-ques-popup"
      >
        <DialogContent>
          <div className="popup-text-container">
            <p>
              Please confirm your submission. Once you click "Yes", your data
              cannot be modified or edited. Are you sure you want to proceed?
            </p>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            padding: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}
        >
          <button
            className="logout-popup-btn primary-btn mars-admin-popup"
            d
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              handleSave("Publish");
              setOpenPopup(false);
            }}
          >
            Yes
          </button>
          <button
            className="logout-popup-btn secondary-btn mars-admin-popup"
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuesPublishPopup;
